import { render, staticRenderFns } from "./EntitiesSettingsTB.vue?vue&type=template&id=5446f87f&"
import script from "./EntitiesSettingsTB.vue?vue&type=script&lang=js&"
export * from "./EntitiesSettingsTB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5446f87f')) {
      api.createRecord('5446f87f', component.options)
    } else {
      api.reload('5446f87f', component.options)
    }
    module.hot.accept("./EntitiesSettingsTB.vue?vue&type=template&id=5446f87f&", function () {
      api.rerender('5446f87f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/routing/EntitiesSettingsTB.vue"
export default component.exports